var exports = {
  "Ur": "VoiceMessageRecorder.module__voiceButtonWrapper___TDJZLU",
  "VK": "VoiceMessageRecorder.module__voiceButton___TDJZLU",
  "qu": "VoiceMessageRecorder.module__voiceButtonIcon___TDJZLU",
  "hB": "VoiceMessageRecorder.module__holdTooltip___TDJZLU",
  "Yh": "VoiceMessageRecorder.module__recordingOverlay___TDJZLU",
  "Zo": "VoiceMessageRecorder.module__overlayInner___TDJZLU",
  "kK": "VoiceMessageRecorder.module__recordingControls___TDJZLU",
  "PJ": "VoiceMessageRecorder.module__recordingBar___TDJZLU",
  "lL": "VoiceMessageRecorder.module__recordingDot___TDJZLU",
  "O1": "VoiceMessageRecorder.module__timer___TDJZLU",
  "ou": "VoiceMessageRecorder.module__waveform___TDJZLU",
  "hd": "VoiceMessageRecorder.module__waveformBar___TDJZLU",
  "gb": "VoiceMessageRecorder.module__iconButton___TDJZLU",
  "T5": "VoiceMessageRecorder.module__trashButton___TDJZLU",
  "jo": "VoiceMessageRecorder.module__sendButton___TDJZLU",
  "QO": "VoiceMessageRecorder.module__lockIndicatorWrapper___TDJZLU",
  "zY": "VoiceMessageRecorder.module__lockIndicator___TDJZLU",
  "bd": "VoiceMessageRecorder.module__lockIndicatorLocked___TDJZLU",
  "GR": "VoiceMessageRecorder.module__lockIndicatorIcon___TDJZLU",
  "c8": "VoiceMessageRecorder.module__lockIndicatorCaret___TDJZLU",
};

module.exports = exports;
